import { DBDocObject } from '@pop-common/legacy/objects/generic/db-doc/db-doc-object';
import { doc } from 'firebase/firestore/lite';

import { getCollectionRef, GetCollectionRefInput } from './get-collection-ref';

export interface GetDocRefInput extends GetCollectionRefInput {
  id: string;
  Deserializer: typeof DBDocObject;
}

export const getDocRef = async ({ id, Deserializer, skipConverter }: GetDocRefInput) => {
  const collectionRef = await getCollectionRef({ Deserializer, skipConverter });
  return doc(collectionRef, id);
};
